/**
 * 거래 관리 API
 * OpenAPI Generator로 생성된 타입을 사용하며, 기존 Axios 인스턴스와 통합
 */
export class TradeService {
    constructor(axiosInstance) {
        Object.defineProperty(this, "axios", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.axios = axiosInstance;
    }
    /**
     * Swap 이자 조회
     * Swap 이자 내역을 조회한다.
     * @param request - Swap 이자 조회 요청 데이터
     * @returns Swap 이자 조회 결과
     */
    getSwapInterest(request) {
        return this.axios.get(`/main/v1/trades/swap-interest`, {
            params: request,
        });
    }
    /**
     * 청산 내역 조회
     * 청산 내역 탭 조회시 사용한다.
     * @param request - 청산 내역 조회 요청 데이터
     * @returns 청산 내역 조회 결과
     */
    getTradeCloseOutOrderHistory(request) {
        return this.axios.get(`/main/v1/trades/liquidation/history`, {
            params: request,
        });
    }
    /**
     * 주문내역 조회
     * 주문내역 탭 조회시 사용한다.
     * @param request - 주문내역 조회 요청 데이터
     * @returns 주문내역 조회 결과
     */
    getTradeHistory(request) {
        return this.axios.get(`/main/v1/trades/history`, {
            params: request,
        });
    }
    /**
     * 청산손익 조회
     * 거래 > 거래내역 > 청산손익 조회시 사용한다.
     * @param request - 청산손익 조회 요청 데이터
     * @returns 청산손익 조회 결과
     */
    getCloseOutHistory(request) {
        return this.axios.get(`/main/v1/trades/close-out/profit-loss`, {
            params: request,
        });
    }
}
//# sourceMappingURL=trade.service.js.map